module.exports = __webpack_public_path__ + "img/showmorw01.d0977bf.png";